<template>
  <div class="view-component">
    <navbar :type="type" :entity="entity" />

    <div class="container" v-if="!ViewParts.every(part => isViewPartPresent(part.type))">
      <div class="box">
        <h1 class="title">View Parts</h1>
        <div class="columns is-multiline">
          <div class="column is-one-third" v-for="part in ViewParts" :key="part.type + part.propertyName">
            <div class="box" :class="{ 'has-text-success': isViewPartPresent(part.type) }">
              <fa-icon :icon="isViewPartPresent(part.type) ? 'check' : 'times'"></fa-icon>
              {{ part.type | toTitleCase }} - {{ part.propertyName }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="entity">
      <div v-masonry transition-duration="300ms" item-selector=".tile">
        <div
          :is="viewPart.component"
          v-for="viewPart in ViewPartComponents"
          :key="viewPart.propertyName"
          :type="type"
          :entity="entity"
          :singular="viewPart.singular"
          :title="viewPart.propertyName"
          class="tile is-half"
          :ref="viewPart.propertyName"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'
import Navbar from './Navbar.vue'

export default {
  name: 'ViewComponent',

  props: {
    load: {
      required: true
    },

    type: {
      required: true
    },

    id: {
      required: true
    }
  },

  data () {
    return {
      isLoaded: false,

      entity: null
    }
  },

  async created () {
    const loader = this.$loading.open()
    try {
      const response = await this.$entity.get(this.type, this.id)

      this.entity = response.data
      loader.close()
    } catch (e) {
      this.$dialog.alert({
        title: `Error`,
        message: e.response.status === 204
          ? `This ${Library.Filters.toTitleCase(this.type)} does not exist.`
          : `<code>${e}</code>`,
        confirmText: 'Return to Search',
        onConfirm: () => this.$entity.toSearch(this.type)
      })
      loader.close()
    }
  },

  mounted () {
    this.$redrawMasonry()
  },

  methods: {
    isViewPartPresent (type) {
      return this.ViewPartComponents.find((part) => part.type === type)
    },

    updated () {
      if (this.isLoaded) {
        return
      }

      if (this.load) {
        const load = this.load.split(',')

        console.log(this.$refs)

        for (const property of load) {
          const comp = this.$refs[property]
          console.log(comp)

          if (Array.isArray(comp)) {
            comp[0].load()
          }
        }

        this.isLoaded = true
      }
    }
  },

  computed: {
    metadata () {
      return this.$store.getters['metadata/findMetaData'](this.type)
    },

    ViewPartComponents () {
      if (this.metadata) {
        return Library.Entities.getViewPartComponents(this.$store, this.type).sort((a, b) => {
          if (a.type === b.type) {
            return 0
          }

          if (a.type === 'Profile' || a.key === null) {
            return -1
          }

          return 1
        })
      } else {
        return []
      }
    },

    ViewParts () {
      return Library.Entities.getViewParts(this.$store, this.type)
    }
  },

  components: {
    Navbar
  }
}
</script>
